import React, { Component } from "react";
import TaskInstancesContainer from "./taskDetail/TaskInstancesContainer";
import { Box, Text } from "grommet";

export class TaskDetail extends Component {
  state = {
    taskInstances: [],
    title: "loading"
  };

  componentDidMount = () => {
    //console.log(this.props);
    let taskInstances = [];
    this.props.shiftData.Shift_Gaurds.forEach(shiftGuard => {
      if (shiftGuard.TaskInstances.length !== 0) {
        const newTaskInstances = taskInstances.concat(shiftGuard.TaskInstances);
        taskInstances = newTaskInstances;
      }
    });
    //console.log("task instances = ", taskInstances);
    const newState = {
      ...this.state,
      taskInstances: taskInstances,
      title: "Tasks"
    };
    this.setState(newState);
  };
  render() {
    if (this.state.title === "loading") {
      return <Box>loading ...</Box>;
    } else {
      return (
        <Box margin="small" alignContent="center">
          <TaskInstancesContainer
            firebase={this.props.firebase}
            currentBuilding={this.props.currentBuilding}
            taskInstances={this.state.taskInstances}
          ></TaskInstancesContainer>
        </Box>
      );
    }
  }
}

export default TaskDetail;
